import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { UsersService } from '../../../services/users.service';
import { NotificationsService } from '../../../services/notification.service';
import { LocalisationService } from '../../../services/localisation.service';
import { BsModalService } from 'ngx-bootstrap';
import { BsModalEventsEmitter } from '../../../events/bsModal.events';
import { DialCodeSelectorModalComponent } from '../dial-code-selector-modal/dial-code-selector-modal.component';
var PersonalInfoSectionComponent = /** @class */ (function () {
    function PersonalInfoSectionComponent(usersService, changeDetectorRef, notificationService, localisationService, bsModalService, bsModalEventsEmitter) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.bsModalService = bsModalService;
        this.bsModalEventsEmitter = bsModalEventsEmitter;
        this.editable = true;
        this.notifications = true;
        this.useSwiper = true;
        this.loading = true;
        this.firstName = new FormControl('', [Validators.required]);
        this.surname = new FormControl('', [Validators.required]);
        this.phone = new FormControl('', [Validators.required]);
        this.age = new FormControl('', [Validators.required, Validators.min(1), Validators.max(Infinity)]);
        this.mailCampaign = true;
        this.weight = new FormControl('', [Validators.required]);
        this.target_weight = new FormControl('', [Validators.required]);
        this.height = new FormControl('', [Validators.required, Validators.min(1), Validators.max(Infinity)]);
        this.selectedPhoneDialCode = '';
        this.dialCodes = require("../../../../../../../config/country_dial_codes.json");
        var language = this.localisationService.getLanguage();
        // if (language && language === Languages.Bulgarian) {
        this.selectedPhoneDialCode = '+359';
        // }
    }
    PersonalInfoSectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        forkJoin(this.usersService.getUserGenders(), this.usersService.getUserBodyTypes())
            .subscribe(function (_a) {
            var genders = _a[0], bodyTypes = _a[1];
            _this.genders = genders;
            _this.bodyTypes = bodyTypes;
            _this.loading = false;
            _this.changeDetectorRef.detectChanges();
            if (_this.usersService.userProfile) {
                _this.initCurrentUserProfile(_this.usersService.userProfile);
            }
        });
    };
    PersonalInfoSectionComponent.prototype.onGenderSelected = function (gender) {
        this.currentlySelectedGender = this.genders.find(function (g) { return g.gender === gender; });
    };
    PersonalInfoSectionComponent.prototype.onSelectedBodyType = function (id) {
        this.currentlySelectedBodyType = id;
    };
    PersonalInfoSectionComponent.prototype.updateProfile = function () {
        var _this = this;
        this.loading = true;
        this.usersService.updateUserProfile({
            first_name: this.firstName.value,
            last_name: this.surname.value,
            dial_code: this.selectedPhoneDialCode,
            phone: this.phone.value,
            age: this.age.value,
            mail_campaign: this.mailCampaign,
            weight: this.weight.value,
            target_weight: this.target_weight.value,
            body_type: {
                id: this.currentlySelectedBodyType.id
            },
            height: this.height.value,
            gender: {
                id: this.currentlySelectedGender.id
            }
        })
            .subscribe(function () {
            _this.loading = false;
            _this.changeDetectorRef.detectChanges();
            if (_this.notifications) {
                _this.notificationService.success(_this.localisationService.localise('settings_profile_updated_successfully'));
            }
        });
    };
    PersonalInfoSectionComponent.prototype.getBodyTypeTranslationKey = function (bodyTypeId) {
        if (bodyTypeId === 4) {
            return 'ectomorph_text';
        }
        if (bodyTypeId === 5) {
            return 'mesomorph_text';
        }
        return 'endomorph_text';
    };
    PersonalInfoSectionComponent.prototype.openDialCodeModal = function () {
        this.dialCodeModal = this.bsModalService.show(DialCodeSelectorModalComponent, {
            backdrop: true
        });
        this.dialCodeModal.content.personalOrWizardComponent = this;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.dialCodeModal);
    };
    Object.defineProperty(PersonalInfoSectionComponent.prototype, "saveButtonIsDisabled", {
        get: function () {
            return !this.weight.valid || !this.target_weight.valid || !this.phone.valid || !this.height.valid || !this.currentlySelectedBodyType || !this.firstName.valid || !this.surname.valid || !this.age.valid || !this.currentlySelectedGender;
        },
        enumerable: true,
        configurable: true
    });
    PersonalInfoSectionComponent.prototype.initCurrentUserProfile = function (userProfile) {
        this.firstName.setValue(userProfile.first_name);
        this.surname.setValue(userProfile.last_name);
        this.phone.setValue((userProfile.phone === null ? '' : userProfile.phone));
        this.age.setValue(userProfile.age);
        this.mailCampaign = userProfile.mail_campaign;
        this.weight.setValue(userProfile.weight);
        this.target_weight.setValue(userProfile.target_weight);
        this.height.setValue(Math.floor(userProfile.height));
        if (userProfile.dial_code !== null && userProfile.dial_code.length > 0) {
            this.selectedPhoneDialCode = userProfile.dial_code;
        }
        this.currentlySelectedBodyType = userProfile.body_type ? this.bodyTypes.find(function (bt) { return bt.id === userProfile.body_type.id; }) : undefined;
        this.currentlySelectedGender = userProfile.gender ? this.genders.find(function (g) { return g.id === userProfile.gender.id; }) : undefined;
        this.changeDetectorRef.markForCheck();
    };
    PersonalInfoSectionComponent.prototype.onMailCampaignChange = function (mailCampaign) {
        this.mailCampaign = mailCampaign;
        this.changeDetectorRef.markForCheck();
    };
    PersonalInfoSectionComponent.prototype.onDialCodeChange = function (event) {
        this.selectedPhoneDialCode = event.target.value;
        this.changeDetectorRef.markForCheck();
    };
    return PersonalInfoSectionComponent;
}());
export { PersonalInfoSectionComponent };
